import React from "react";
import Label from "./Label";
// import Firebase from "../../constants/Firebase";
import AddLabelModal from "../modals/AddLabelModal";

class Category extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			modalIsOpen: false,
		};
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	// OPEN LABEL MODAL
	openModal() {
		this.setState({
			modalIsOpen: true,
		});
	}

	// CLOSE LABEL MODAL
	closeModal() {
		this.setState({
			modalIsOpen: false,
		});
	}

	render() {
		// LABEL OR EMPTY OBJECT
		const labels = this.props.category.labels ? this.props.category.labels : {};

		return (
			<ul className="Category">
				<div className="tab-header-div">
					{/* ADD LABEL MODAL */}
					<AddLabelModal
						openModal={this.openModal}
						closeModal={this.closeModal}
						modalIsOpen={this.state.modalIsOpen}
						fetchFirebase={this.props.fetchFirebase}
						user={this.props.user}
						tabID={this.props.tabID}
						catID={this.props.catID}
						catTitle={this.props.category.title}
					/>
				</div>

				{/* LI MAP LABEL */}
				<li>
					{Object.keys(labels).map((labelID, index) => {
						return (
							// LABEL COMPONENT
							<Label
								links={labels[labelID].links}
								title={labels[labelID].title}
								tabID={this.props.tabID}
								catID={this.props.catID}
								labelID={labelID}
								user={this.props.user}
								key={labelID}
								fetchFirebase={this.props.fetchFirebase}
							/>
						);
					})}
				</li>
			</ul>
		);
	}
}

export default Category;
